import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import BullsEye from '../../../Prototype/Level/Card/BullsEye';
import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import SpriteComponent from '../../../Component/Render/Sprite';
import Renderable from '../../../Component/Renderable';
import { Random } from '../../../Utility/Random';
import { delay } from '../../../Utility/Task/TaskQueue';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import CardSystem from '../../Card/CardSystem';
import { showCardScoreEffectAt } from '../CardAnimationHelper';
import { UIEvent } from '../../UI/BaseUISystem';
import StreakBar from '../../../Prototype/UI/Level/StreakBar';
import { AwaitIterators } from '../AnimationHelper';

export class BoosterBullsEye extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: {
            system: CardSystem;
            cards: BaseCard[];
            score: number;
        }
    ): IterableIterator<number> {
        for (let card of meta.cards) {
            animator.addChild(card);
        }

        yield* delay(600);

        const scalesTween = [];
        const cards = [];
        for (let card of meta.cards) {
            const bullsEye = GameObject.Instantiate(BullsEye);
            animator.addChild(bullsEye);

            const cardTransform = card.getComponent(TransformComponent);
            const bullsEyeTransform = bullsEye.getComponent(TransformComponent);
            const bullsEyeSprite = bullsEye.getComponent(SpriteComponent);

            bullsEyeTransform.position.set(
                cardTransform.position.x,
                cardTransform.position.y
            );

            bullsEyeTransform.scale.set(2, 2);


            const scaleTween = this.getTween(bullsEyeTransform.scale);
            scaleTween.to({ x: 1, y: 1 }, 300).easing(Easing.Circular.Out);
            scalesTween.push(this.startTween(scaleTween));

            cards.push({card: card, bullsEyeTransform: bullsEyeTransform, bullsEyeSprite: bullsEyeSprite, scaleTween: scaleTween})
        }

        yield* AwaitIterators(scalesTween);

        yield* delay(350);

        for (let card of cards) {
            // Hide card.
            this.cardFlip(card.card);

            showCardScoreEffectAt(
                meta.system.scene,
                animator,
                meta.score,
                card.bullsEyeTransform.position.clone()
            );
        }

        PlaySound('bullseye');

        StreakBar.instance.update();
        //bullsEyeTransform.scale.set(, 0.8);

        for (let card of cards) {
            card.card.hideAndDestroyModifiers();
            const alphaTween = this.getTween(card.bullsEyeSprite);
            alphaTween
                .to({ alpha: 0 }, 200)
                .delay(100)
                .start(this.elapsedTime);

            card.scaleTween
                .to({ x: 1.5, y: 1.5 }, 50)
                .easing(Easing.Quadratic.Out)
                .start(this.elapsedTime);

            yield* delay(50);
        }

        for (let card of cards) {
            card.scaleTween
                .to({ x: 1.2, y: 1.2 }, 100)
                .easing(Easing.Quadratic.InOut)
                .start(this.elapsedTime);
        }

        meta.system.scene.emit(UIEvent.RESTORE_INTERACTIVITY, true);

        yield* delay(500);

        for (let card of cards) {
            card.bullsEyeSprite.visible = false;
        }
    }

    private cardFlip(card: BaseCard) {
        const cardTransform = card.getComponent(TransformComponent);
        const tweenX = this.getTween(cardTransform.position);
        const tweenY = this.getTween(cardTransform.position);
        const tweenRotation = this.getTween(cardTransform);
        const tweenAlpha = this.getTween(card.getComponent(Renderable));

        tweenX.to(
            { x: cardTransform.x + (Random.int(0, 1) * 2 - 1) * 400 },
            500
        );
        tweenX.start(this.elapsedTime);

        tweenY.to({ y: cardTransform.y - 100 }, 250);
        tweenY.start(this.elapsedTime);

        // Fade out.
        tweenAlpha.to({ alpha: 0 }, 150);
        tweenAlpha.delay(350);
        tweenAlpha.start(this.elapsedTime);

        tweenRotation.to({ rotation: Math.PI * 4 }, 500);
        tweenRotation.start(this.elapsedTime);
    }
}
